import { AssistantConfigWindow } from '../../../types';
import { getConfig } from '../../../utils/config';

declare let window: AssistantConfigWindow;

const decodeSearchParamsToString = (searchParams: URLSearchParams) => decodeURIComponent(searchParams.toString());

export const getUrl = (): string => {
  // to avoid requiring that the user pass in the domain and protocol, we can get it from the script source
  // const domain = document.getElementById('assistant-webchat-script')?.src.split('/')[2];

  const scripts = document.getElementById('assistant-config') as HTMLScriptElement;
  const domain = scripts?.src.split('/')[2];

  const { assetUID, accessCode, target, cst, context, flags } = window?.assistantConfig || {};

  const searchParams = new URLSearchParams();

  assetUID && searchParams.append('assetUID', assetUID);
  accessCode && searchParams.append('accessCode', accessCode);
  cst && searchParams.append('cst', cst);
  target && searchParams.append('target', target);
  context && searchParams.append('context', context);
  flags && searchParams.append('flags', flags);

  const config = getConfig();

  const url = `https://${domain}${config.CHAT_PATH}?&${decodeSearchParamsToString(searchParams)}`;

  return url;
};
